"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contrast = void 0;

var _luminance = require("./luminance");

/**
 * Calculates the contrast ratio of two colors,  based on their luminance
 *
 * @param background [r,g,b] value tuple
 * @param text [r,g,b] value tuple
 *
 * @returns the contrast ratio between two colors
 */
var contrast = function contrast(background, text) {
  var l1 = (0, _luminance.luminance)(background) + 0.05;
  var l2 = (0, _luminance.luminance)(text) + 0.05;
  return Math.max(l1, l2) / Math.min(l1, l2);
};

exports.contrast = contrast;